module.exports = __webpack_public_path__ + "img/demo1-poster.46123323.jpg";